module.exports = __webpack_public_path__ + "img/teaser_001.80554aac.png";